const focusTrapModal = (targetModal: HTMLElement) => {
    const focusableElements = 'button, iframe, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableContent = Array.from(targetModal.querySelectorAll(focusableElements));
    const firstFocusableElement = focusableContent[0] ?? null;
    const lastFocusableElement = focusableContent[focusableContent.length - 1] ?? null;

    const handleKeyDown = (e: KeyboardEvent) => {
        const isTabPressed = e.key === 'Tab';
        if (!isTabPressed) return;

        if (e.shiftKey) { 
            if (document.activeElement === firstFocusableElement) {
                (lastFocusableElement as HTMLElement).focus(); 
                e.preventDefault();
            }
        } else { 
            if (document.activeElement === lastFocusableElement) { 
                (firstFocusableElement as HTMLElement).focus(); 
                e.preventDefault();
            }
        }
    }

    if (focusableContent.length) {
        document.body.addEventListener('keydown', handleKeyDown);
        (firstFocusableElement as HTMLElement).focus();
    }
}

export default focusTrapModal;